import { defineComponent as o, createBlock as t, openBlock as n, resolveDynamicComponent as l, withCtx as r, renderSlot as a } from "vue";
const s = /* @__PURE__ */ o({
  name: "PfGalleryItem",
  __name: "GalleryItem",
  props: {
    component: { default: "div" }
  },
  setup(m) {
    return (e, p) => (n(), t(l(e.component), null, {
      default: r(() => [
        a(e.$slots, "default")
      ]),
      _: 3
    }));
  }
});
export {
  s as default
};
